export const TOASTS = {
  CREATE_RULES: {
    RULES_CREATE_SUCCESS: {
      success: true,
      text: 'Reward Rule created successfully',
      description: 'Your rule has been created and is ready to be utilized.',
    },
    RULES_CREATE_FAILURE: {
      success: false,
      text: 'Something went wrong',
      description: 'Unfortunately, we couldn’t save the reward rule. Please try again in a few minutes.',
      dismissible: false,
    },
  },

  UPDATE_RULES: {
    RULES_UPDATE_SUCCESS: {
      success: true,
      text: 'Reward Rule created successfully',
      description: 'Reward rule updated successfully. Your changes have been saved',
    },
    RULES_UPDATE_FAILURE: {
      success: false,
      text: 'Something went wrong',
      description: 'Unfortunately, we couldn’t create the group. Please try again in a few minutes.',
      dismissible: false,
    },
  },

  DEACTIVATE_RULES: {
    RULES_DEACTIVATE_SUCCESS: {
      success: true,
      text: 'Rule updated successfully',
      description:
        'Your rule has been updated and will be applied immediately or applied at the start of the active period. It will be deactivated once the period ends.',
    },
    RULES_DEACTIVATE_FAILURE: {
      success: true,
      text: 'Something went wrong',
      description: 'Unfortunately, we couldn’t update the rule please try again.',
      dismissible: false,
    },
  },

  CREATE_CATEGORY: {
    CATEGORY_CREATE_SUCCESS: {
      success: true,
      text: 'Category created successfully',
      description: 'Your category has been created and is ready to be utilized.',
    },
    CATEGORY_CREATE_FAILURE: {
      success: false,
      text: 'Something went wrong',
      description:
        'Unfortunately, we couldn’t create the category because it contains duplicative logic with the existing category, [Category Name].',
      dismissible: false,
    },
  },

  UPDATE_CATEGORY: {
    CATEGORY_UPDATE_SUCCESS: {
      success: true,
      text: 'Category updated successfully',
      description: 'Your changes have been saved.',
    },
    CATEGORY_UPDATE_FAILURE: {
      success: false,
      text: 'Something went wrong',
      description:
        'Unfortunately, we couldn’t update the category because it contains duplicative logic with the existing category, [Category Name].',
      dismissible: false,
    },
  },

  CREATE_PARTNER: {
    GROUP_CREATE_SUCCESS: {
      success: true,
      text: 'Partner created successfully',
      description: 'The new partner has been created.',
    },
    GROUP_CREATE_FAILURE: {
      success: false,
      text: 'Something went wrong',
      description: 'Unfortunately, we couldn’t create the group. Please try again in a few minutes.',
      dismissible: false,
    },
  },

  UPDATE_GROUP: {
    GROUP_UPDATE_SUCCESS: {
      success: true,
      text: 'Group updated successfully.',
      description: 'Your changes have been saved.',
    },
    GROUP_UPDATE_FAILURE: {
      success: false,
      text: 'Something went wrong',
      description: 'Unfortunately, we couldn’t update the group. Please try again in a few minutes.',
      dismissible: false,
    },
  },

  UPDATE_PARTNER: {
    PARTNER_UPDATE_SUCCESS: {
      success: true,
      text: 'Partner updated successfully.',
      description: 'Your changes have been saved.',
    },
    PARTNER_UPDATE_FAILURE: {
      success: false,
      text: 'Something went wrong',
      description: 'Unfortunately, we couldn’t update the partner. Please try again in a few minutes.',
      dismissible: false,
    },
  },

  COPY_JSON: {
    JSON_COPY_SUCCESS: {
      success: true,
      text: 'JSON copied to clipboard',
      description: 'Business data has been copied to your clipboard.',
    },
    JSON_COPY_FAILURE: {
      success: false,
      text: 'Copy failed',
      description: 'Unable to copy JSON to clipboard. Please try again.',
      dismissible: true,
    },
  },
}
